import type { Motivation } from '../types/content'

export const motivations: Motivation[] = [
  {
    id: 'voor-jezelf',
    label: 'Voor jezelf',
    title: 'Een moment voor jezelf',
    description:
      'Kies een project, leg je materialen klaar en maak rustig tijd om iets te maken.',
    benefits: [
      'Een bezigheid om rustig van te genieten',
      'Projecten die je kiest op basis van je niveau',
      'Het plezier van iets met je eigen handen maken',
    ],
    image: 'https://cdn.magicpatterns.com/uploads/8iMS4Pv7mh53CgFSCTynaq/per_te.png',
    imageAlt:
      'Handen die een hartje van lila punnikkoord vormen op een houten tafel, naast pastelkleurige bolletjes garen, een roze punnikmolen, metaaldraad, een tang en een schaar',
  },
  {
    id: 'om-te-decoreren',
    label: 'Om te decoreren',
    title: 'Decoraties die bij je passen',
    description:
      'Speel met vormen, beginletters en kleuren om je eigen plekjes een persoonlijk tintje te geven.',
    benefits: [
      'Beginletters en namen om te personaliseren',
      'Vormen en kleuren die jij kiest',
      'Kleine details voor in huis',
    ],
    image: 'https://cdn.magicpatterns.com/uploads/s1yuU5HasM1Sf1BaoAh7k4/per_decorare.png',
    imageAlt:
      'Houten plank met pastelkleurige boeken, een lila letter E van punnikkoord en een vaas met tulpen en bloemen van roze, lila en geel punnikkoord',
  },
  {
    id: 'om-te-geven',
    label: 'Om cadeau te geven',
    title: 'Cadeaus gemaakt met liefde',
    description:
      'Maak van een idee een kleine attentie voor iemand die je dierbaar is.',
    benefits: [
      'Een cadeautje dat je zelf hebt gemaakt',
      'Kleuren gekozen voor wie het krijgt',
      'Ideeën voor bijzondere gelegenheden',
    ],
    image: 'https://cdn.magicpatterns.com/uploads/o5t7it54EVEqw3FeJ5J2qC/per_regalare.png',
    imageAlt:
      'Handen die met een lila lint een cadeaudoos dichtmaken, versierd met een letter M en een bloem van punnikkoord, naast een vlinder van punnikkoord in een doosje en een roze organza zakje',
  },
]
